import { InputAdornment, styled, Theme } from '@nexelem/deprecated-theme';

export const DropdownIndicatorContainer = styled(InputAdornment)(({ theme }) => {
  const typedTheme = theme as Theme;
  const { getColor } = typedTheme.palette;
  const { defaultState } = typedTheme.client.inputs.selectFieldItem;
  return {
    '&& .MuiAutocomplete-endAdornment': {
      right: 0,
      '.MuiAutocomplete-clearIndicator': {
        '&:active': {
          backgroundColor: 'transparent',
        },
      },
    },
    '.MuiAutocomplete-popupIndicator': {
      cursor: 'inherit',
      width: typedTheme.spacing(10),
      height: typedTheme.spacing(10),
      color: `${getColor(defaultState.dropdownIndicator)}`,
      ':hover svg': {
        color: `${getColor(defaultState.dropdownIndicator)}`,
      },
      ':active': {
        backgroundColor: 'transparent',
      },
    },
    '.MuiTouchRipple-root': {
      display: 'none',
    },
  };
});
